import { State } from '@meraki-internal/state';
import { CareMapState, ICareMapOnboardingStep } from '../caremap/CareMapState';

type IChecklistAutoExpandState = {
    expandIndex: number;
    collapseOthers?: boolean;
};

type IChecklistState = {
    autoExpandInfo?: IChecklistAutoExpandState;
};

export type IFinancialChecklist = 'getting-started' | 'estate-planning' | 'advance-care';

// NOTE: this is the order of the checklist groups and needs to match the
//  sequence (order) of ids in the API in ArticleToCaremapChecklistCreator
export const FINANCIAL_CHECKLIST_SEQUENCE_MAP: {[key in IFinancialChecklist]: number} = {
    'getting-started': 0,
    'estate-planning': 1,
    'advance-care': 2
};

export class ChecklistState extends State<IChecklistState> {
    static inject = () => [
        CareMapState
    ];

    constructor(
        private careMapState: CareMapState
    ) {
        super({ });
    };

    getAutoExpandInfo = () => {
        return this.state.autoExpandInfo;
    };

    setAutoExpandInfo = (info: IChecklistAutoExpandState) => {
        this.setState({ autoExpandInfo: info });
    };

    clearAutoExpandInfo = () => {
        this.setState({ autoExpandInfo: undefined });
    };

    completeOnboardingStep = (step: ICareMapOnboardingStep) => {
        this.careMapState.completeOnboardingStep(step);
    };
};
